import { parseLifeExpectancyData } from "../lib/parse-life-expectancy-data";
import { createInMemoryLifeExpectancy } from "./in-memory-life-expectancy";
import type { LifeExpectancyLookup } from "./life-expectancy-port";

const DEFAULT_DATA_URL = "/life-expectancy.json";

export type RawJsonReader = () => Promise<unknown>;

export async function loadJsonLifeExpectancy(
  reader: RawJsonReader = defaultJsonReader,
): Promise<LifeExpectancyLookup> {
  const raw = await reader();
  const data = parseLifeExpectancyData(raw);
  return createInMemoryLifeExpectancy(data);
}

async function defaultJsonReader(): Promise<unknown> {
  const response = await fetch(DEFAULT_DATA_URL);
  if (!response.ok) {
    throw new Error(`Failed to load ${DEFAULT_DATA_URL}: HTTP ${response.status}`);
  }
  return response.json();
}
